import { inject } from '../../container/inject';
import { EntityStoreToken, IEntityStore, IEntityStoreFactory } from '../interface/IEntityStore';

export function injectEntity<Type>(defaultValue: Type): IEntityStore<Type> {
  return inject<IEntityStoreFactory<Type>>(EntityStoreToken)(defaultValue);
}
